import { render, staticRenderFns } from "./mapAsset.vue?vue&type=template&id=57150ce4&"
import script from "./mapAsset.vue?vue&type=script&lang=js&"
export * from "./mapAsset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports